import pqColorLogo from '@/assets/pq_color_logo.svg';
import { ActionIcon, Anchor, Badge, Center, Drawer, Group, Image, Stack, Text } from "@mantine/core";
import { IconCheckupList, IconLifebuoyFilled, IconListCheck, IconMessage2Question, IconShoppingCart, IconUserCircle, IconX } from "@tabler/icons-react";
import { NavLink } from 'react-router';
import { useAuth } from '../Auth';
import { useCart } from '../Cart';

export type LeftNavProps = {
    opened: boolean
    currentUser: any | null
    onClose: () => void
    onLoginClick: () => void
}

const LeftNav: React.FC<LeftNavProps> = ({ opened, currentUser, onClose, onLoginClick }) => {
    const { logout } = useAuth();
    const { itemCount } = useCart();
    const onLogoutClick = () => {
        logout();
    }
    return (
        <Drawer
            opened={opened}
            aria-expanded={opened? 'true' : 'false'}
            role="region"
            aria-hidden={!opened ? 'true' : 'false'}
            aria-labelledby='navbar-burger'
            onClose={onClose}
            position='left'
            size='100%'
            styles={{ body: { height: '100%' } }}
            withCloseButton={false}>
            <Stack align='start' p='md' h='100%'>
                <Group align='center' justify='space-between' w='100%'>
                    <Center>
                        <Anchor href='/'>
                            <Image style={{objectFit: 'contain'}} src={pqColorLogo} alt='ParcelQuest Guard Dog Service' height={40} />
                        </Anchor>
                    </Center>
                    <ActionIcon aria-label="Close navigation drawer" onClick={onClose} size='lg' variant='transparent' color='gray' radius='xl'>
                        <IconX />
                    </ActionIcon>
                </Group>
                {currentUser ?
                    <NavLink onClick={onClose} style={{ textDecoration: 'none' }} to='/dashboard'><Group><IconListCheck color='black'/><Text c='pq-red' fw='600' size='16px'>DASHBOARD</Text></Group></NavLink> :
                    <NavLink onClick={onClose} style={{ textDecoration: 'none' }} to='/register'><Group><IconCheckupList color='black' /><Text c='pq-red' fw='600' size='16px'>SIGN UP</Text></Group></NavLink>
                }
                <NavLink onClick={onClose} style={{ textDecoration: 'none' }} to='/faq'><Group><IconMessage2Question color='black' /><Text c='pq-red' fw='600' size='16px'>FAQ</Text></Group></NavLink>
                <NavLink onClick={onClose} style={{ textDecoration: 'none' }} to='/support'><Group><IconLifebuoyFilled color='black' /><Text c='pq-red' fw='600' size='16px'>SUPPORT</Text></Group></NavLink>
                {currentUser && (
                    <NavLink onClick={onClose} style={{ textDecoration: 'none' }} to='/cart'>
                        <Group>
                            <IconShoppingCart color='black' />
                            <Text c='pq-red' fw='600' size='16px'>CART</Text>
                            {itemCount > 0 && (
                                <Badge color="pq-red" size="sm" circle>
                                    {itemCount}
                                </Badge>
                            )}
                        </Group>
                    </NavLink>
                )}
                {currentUser ?
                    <Anchor td='none' onClick={onLogoutClick}><Group><IconUserCircle color='black' /><Text c='pq-red' fw='600' size='16px'>LOGOUT</Text></Group></Anchor> :
                    <Anchor td='none' onClick={onLoginClick}><Group><IconUserCircle color='black' /><Text c='pq-red' fw='600' size='16px'>LOGIN</Text></Group></Anchor>
                }
            </Stack>
        </Drawer>

    )
}

export default LeftNav;